/* Serial Ajax cart changes; Shopify remains the authority for stock, discounts and totals. */
(() => {
  'use strict';
  if (!window.fetch) return;
  let timer, busy=false;
  const root=()=>document.querySelector('[data-cart-section]');
  const text=key=>root()?.getAttribute('data-cart-i18n-'+key)||'';
  const pending=new Map();
  const status=(message,error=false)=>{const el=root()?.querySelector('[data-cart-status]');if(el){el.hidden=!message;el.textContent=message;el.setAttribute('role',error?'alert':'status');}};
  const setBusy=value=>{busy=value;const box=root();if(!box)return;box.setAttribute('aria-busy',String(value));box.querySelectorAll('[data-cart-quantity],button[name=checkout],button[name=update]').forEach(e=>e.disabled=value);};
  const endpoint=path=>(window.Shopify?.routes?.root||'/')+path;
  const updateCount=count=>{document.querySelectorAll('[data-cart-count]').forEach(e=>e.textContent=String(count));document.querySelectorAll('.fl-cart-link').forEach(e=>e.setAttribute('aria-label',text('label').replace('__count__',String(count))));};
  const replaceSection=html=>{
    const current=root();const doc=new DOMParser().parseFromString(html,'text/html');const next=doc.querySelector('[data-cart-section]');
    if(!current||!next)throw Error(text('display-error'));
    const note=current.querySelector('[name=note]')?.value;const active=document.activeElement;const activeKey=active?.dataset?.lineKey;
    if(note!==undefined&&next.querySelector('[name=note]'))next.querySelector('[name=note]').value=note;
    next.querySelectorAll('script').forEach(e=>e.remove());current.replaceWith(next);
    if(activeKey){const input=[...next.querySelectorAll('[data-cart-quantity]')].find(e=>e.dataset.lineKey===activeKey);input?.focus({preventScroll:true});}
    enhance();
  };
  const reconcile=async sectionId=>{
    const url=new URL(endpoint('cart'),location.origin);url.searchParams.set('sections',sectionId);
    const response=await fetch(url,{credentials:'same-origin',cache:'no-store'});if(!response.ok)throw Error(text('unreachable'));
    const sections=await response.json();if(!sections[sectionId])throw Error(text('reload'));replaceSection(sections[sectionId]);
    try{const r=await fetch(endpoint('cart.js'),{credentials:'same-origin',cache:'no-store'});if(r.ok){const cart=await r.json();updateCount(cart.item_count);}}catch{}
  };
  function enhance(){const box=root();if(!box)return;box.dataset.cartEnhanced='true';}
  async function flush(){
    clearTimeout(timer);if(busy||!pending.size)return;
    const box=root();if(!box)return;const sectionId=box.dataset.cartSection;
    const changes=[...pending];pending.clear();setBusy(true);status(text('updating'));
    let finalCart;
    try{
      for(const [key,quantity] of changes){
        const response=await fetch(endpoint('cart/change.js'),{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:key,quantity,sections:[sectionId],sections_url:endpoint('cart')})});
        const data=await response.json().catch(()=>{throw Error(text('network'));});
        if(!response.ok)throw Error(typeof data.description==='string'?data.description:text('quantity-error'));
        finalCart=data;
      }
      if(finalCart?.sections?.[sectionId])replaceSection(finalCart.sections[sectionId]);else await reconcile(sectionId);
      updateCount(finalCart.item_count);
      status(text('updated'));
    }catch(error){
      // Never repeat a mutation after an uncertain network response. Read the current server state instead.
      try{await reconcile(sectionId);}catch{root()?.querySelectorAll('[data-cart-quantity]').forEach(e=>e.value=e.dataset.currentQuantity);}
      const box=root();if(box)delete box.dataset.cartEnhanced;
      status(`${error.message || text('failed')} ${text('recovery')}`,true);
    }finally{setBusy(false);}
  }
  document.addEventListener('input',event=>{
    const input=event.target.closest('[data-cart-quantity]');if(!input||busy)return;clearTimeout(timer);
    if(!input.checkValidity()){pending.delete(input.dataset.lineKey);status(text('invalid-quantity'),true);return;}
    if(Number(input.value)===Number(input.dataset.currentQuantity))pending.delete(input.dataset.lineKey);else pending.set(input.dataset.lineKey,Number(input.value));
    status(pending.size?text('changed'):'');timer=setTimeout(flush,500);
  });
  document.addEventListener('submit',event=>{
    if(event.target.id!=='FellinoCartForm')return;
    if(busy){event.preventDefault();return;}
    if(pending.size){event.preventDefault();const checkout=event.submitter?.name==='checkout';flush().then(()=>{if(checkout&&root()?.dataset.cartEnhanced==='true'){const form=root().querySelector('form');const button=form?.querySelector('[name=checkout]');if(button)form.requestSubmit(button);}});}
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',enhance);else enhance();
  document.addEventListener('shopify:section:load',enhance);
})();
